import * as ActionType from "../actionType";
import { fetchPromotionPageApi } from "../../services/page/promotionpage";

const getPromotionPageAction = () => {
  return async dispatch => {
    dispatchPromotionPage(dispatch);
  };
};

const dispatchPromotionPage = dispatch => {
  fetchPromotionPageApi().then(data => {
    dispatch({
      type: ActionType.RECEIVE_PROMOTION_PAGE,
      data
    });
  });
};

export { getPromotionPageAction, dispatchPromotionPage };



// WEBPACK FOOTER //
// ./src/actions/page/promotionpage.js